// The document title doubles as the page_view's page_title, and a page still
// loading its data shows a "Loading…" placeholder. useDocumentTitle reports
// here whether the current page's title has settled, so useAnalyticsPageViews
// can hold the page_view until it names the real page instead of the
// placeholder — half of all page views used to land in GA4 as "Loading…".
let settled = true
let waiting: (() => void) | null = null

export function reportTitle(state: 'loading' | 'settled') {
  settled = state === 'settled'
  if (!settled) return
  const fn = waiting
  waiting = null
  fn?.()
}

// A page giving up the title (unmount) makes no announcement: the next page
// reports its own state before anyone asks, and a page that never declares
// one counts as settled so its page_view is never held.
export function releaseTitle() {
  settled = true
}

export function whenTitleSettled(fn: () => void): () => void {
  if (settled) {
    fn()
    return () => {}
  }
  waiting = fn
  return () => {
    if (waiting === fn) waiting = null
  }
}
